export const forgeProofContent = {
  title: "Claim Your 14-Day Free Lead-Rescue Test",
  bodyBefore: "We deploy the infrastructure ",
  code: "for free for 14 days.",
  bodyAfter:
    " If the algorithm doesn't save at least 2 estimate inspections that you would have guaranteed lost in those 2 weeks, you simply turn off the widget. No charges, no card attachments, and no complex contracts.",
  cta: "Deploy 14-Day Free Roofing Digital Assistant",
  notes: [
    "No credit card required",
    "12-minute setup or done-for-you concierge onboarding",
    "Cancel anytime in 1 click",
  ],
  windowLines: [
    "[Oct 1st, 03:44] John - booked appointment",
    "[Oct 1st, 05:23] David - booked appointment",
    "[Oct 2nd, 05:23] Alex - booked appointment",
  ],
}
